import { render, staticRenderFns } from "./uncheck.vue?vue&type=template&id=38e71e13&"
import script from "./uncheck.vue?vue&type=script&lang=js&"
export * from "./uncheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports